export const normalizeSearch = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length === 0 ? undefined : trimmed;
};

export const shouldApplySearchUpdate = (
  current: string | undefined,
  next: string | undefined,
  lastApplied: string | undefined
): boolean => {
  if (next === current) return false;
  if (next === lastApplied) return false;
  return true;
};
